(function () {
  angular
    .module("akitabox.ui.components.missingOrganization", [])
    .component("abxMissingOrganization", {
      templateUrl:
        "app/core/ui/components/missing-organization/missing-organization.component.html",
    });
})();
